export const ALLOWED_SORTING_TYPES = {
    systemProperty: {
        name: 'System Property',
        description: 'System property of the documents being sorted',
        value: 'systemProperty'
    },
    descriptor: {
        name: 'Document Attribute',
        description: 'Document attribute that exists on a document being sorted',
        value: 'descriptor'
    }
};

export const ALLOWED_SORTING_SYSTEM_PROPERTIES = {
    documentType: {
        name: 'Document Type Name',
        description: 'Display name of the document type',
        value: 'documentType.displayName'
    },
    documentName: {
        name: 'Document Name',
        description: 'Display name of the document',
        value: 'name'
    },
    documentStatus: {
        name: 'Document Status',
        description: 'Status of the document (unindexed, indexed)',
        value: 'documentStatus'
    },
    commitDate: {
        name: 'Date Committed',
        description: 'Date that the document was indexed',
        value: 'commitDate'
    },
    uploadDate: {
        name: 'Date Uploaded',
        description: 'Date that the document was uploaded',
        value: 'uploadDate'
    },
    uploadUser: {
        name: 'Uploaded By',
        description: 'The user that uploaded the document',
        value: 'uploadUser.displayName'
    }
};

export const ALLOWED_SORTING_DIRECTIONS = {
    ascending: {
        name: 'Ascending',
        description: '\'Less than\' values appear first',
        value: 'ascending'
    },
    descending: {
        name: 'Descending',
        description: '\'Greater than\' values appear first',
        value: 'descending'
    }
};
